import { HiOutlineCheck, HiOutlineXMark } from 'react-icons/hi2';

import { Button } from '@/components-new/button';
import { Spinner } from '@/components-new/spinner';

type EditingActionsCellProps = {
  disabled: boolean;
  saving: boolean;
  onSave: () => void;
  onCancel: () => void;
};

export const EditingActionsCell = ({ disabled, saving, onSave, onCancel }: EditingActionsCellProps) => {
  return (
    <div className="flex items-center">
      <Button plain aria-label="Cancel" onClick={onCancel} disabled={disabled}>
        <HiOutlineXMark/>
      </Button>
      {!saving && (
        <Button plain aria-label="Save" onClick={onSave} disabled={disabled}>
          <HiOutlineCheck/>
        </Button>
      )}
      {saving && <Spinner />}
    </div>
  );
};
